import { render } from "./TermAndConditionView.vue?vue&type=template&id=df443a2a&scoped=true"
import script from "./TermAndConditionView.vue?vue&type=script&lang=js"
export * from "./TermAndConditionView.vue?vue&type=script&lang=js"

import "./TermAndConditionView.vue?vue&type=style&index=0&id=df443a2a&scoped=true&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df443a2a"]])

export default __exports__